import { render, staticRenderFns } from "./PublicSolutionDetails.vue?vue&type=template&id=d12508a8&scoped=true"
import script from "./PublicSolutionDetails.vue?vue&type=script&lang=js"
export * from "./PublicSolutionDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicSolutionDetails.vue?vue&type=style&index=0&id=d12508a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12508a8",
  null
  
)

export default component.exports